import { createSlice } from "@reduxjs/toolkit";

import getDBDateTimeNow from "../funcs/date_time_funcs";

// ---------- Helpers -----------

const getScores = (results_a) => {
	let res = results_a.reduce(
		(js, elem) => {
			let earned_n,
				possible_n = 0;
			if (elem.type === "text") {
				earned_n = elem.score_a.reduce((cum, curr) => cum + curr, 0);
				possible_n = elem.score_a.length;
			}
			if (
				elem.type === "radios" ||
				elem.type === "dropdown" ||
				elem.type === "textarea" ||
				elem.type === "affective" ||
				elem.type === "check_several"
				) {
				earned_n = elem.score;
				possible_n = 1;
			}
			js.earned = js.earned + earned_n;
			js.possible = js.possible + possible_n;
			if (js.possible === 0) {
				js.percent = 0.0;
			} else {
				js.percent = Math.round((js.earned / js.possible) * 1000) / 10;
			}
			return js;
		},
		{ earned: 0, possible: 0, percent: 0.0 }
	);
	return res;
};

// ------------------------------

export const activityStates = createSlice({
	name: "activityStates",
	initialState: {
		init_complete_bool: false,
		items_a: [],
		results_a: [],
		scores_js: { earned: 0, possible: 0, percent: 0.0 },
		items_incomplete_a: [],
		saved_bool: false,
		items_show_checkanswer_bool: false,
		items_show_explanation_bool: false,
		post_completion_html_show_bool: false
	},
	reducers: {
		initActivityState: (state, action) => {
			// {items_a}
			let js = action.payload;
			// Exclude any items of type HTML
			const items_a = js.items_a.filter( (item) => {
				if ( item.definitions_js.type === "html" ) {
					return false;
				} else {
					return true;
				}
			});
			state.items_a = items_a;
			state.results_a = items_a.map((elem) => {
				let res;
				switch (elem.definitions_js.type) {
					case "radios":
						res = { type: "radios", response: "", score: 0, correct: false };
						break;
					case "dropdown":
						res = { type: "dropdown", response: "", score: 0, correct: false };
						break;						
					case "text":
						let n = elem.data_js.answers_js_a.length;
						res = {
							type: "text",
							response_a: [...Array(n).keys()].map((x) => ""),
							score_a: [...Array(n).keys()].map((x) => 0),
							correct_a: [...Array(n).keys()].map((x) => false)
						};
						break;
					case "textarea":
						res = { type: "textarea", response: "", score: 0, correct: false };
						break;
					case "affective":
						res = { type: "affective", response: "", score: 0, correct: false };
						break;	
					case "check_several":
						res = { type: "check_several", response: "", score: 0, correct: false };
						break;		
					default:
						console.log("Unknown definitions_js type");
						res = {};
						break;
				}
				return res;
			});
			state.scores_js = getScores(state.results_a);
			state.saved_bool = false;
			state.items_show_checkanswer_bool = false;
			state.items_show_explanation_bool = false;
			state.post_completion_html_show_bool = false;
			activityStates.caseReducers.updateIncompletes(state, {});
			// Note:
			// state.init_complete_bool gets set to true after the initial
			// call of updateIncompletes
		},
		recordItem: (state, action) => {
			let js = action.payload;
			if (state.results_a[js.answer_index] !== undefined) {
				switch (state.results_a[js.answer_index].type) {
					case "radios":
					case "dropdown":
					case "textarea":
					case "affective":
					case "check_several":					
						// payload: {answer_index, response, score, correct}
						state.results_a[js.answer_index].response = js.response;
						state.results_a[js.answer_index].score = js.score;
						state.results_a[js.answer_index].correct = js.correct;
						break;
					case "text":
						// payload: { answer_index, nested_answer_index, response, score, correct }
						state.results_a[js.answer_index].response_a[
							js.nested_answer_index
						] = js.response;
						state.results_a[js.answer_index].score_a[js.nested_answer_index] =
							js.score;
						state.results_a[js.answer_index].correct_a[js.nested_answer_index] =
							js.correct;
						break;
					default:
						console.log("Unknown definitions_js type");
						break;
				}
				state.scores_js = getScores(state.results_a);
				activityStates.caseReducers.updateIncompletes(state, {});
			}
		},
		updateIncompletes: (state, action) => {
			state.items_incomplete_a = state.results_a
				.map((elem, i) => {
					let res;

					const checkText = (items_a, response_a, i) => {
						const re = new RegExp(items_a[i].validation_js.required);
						const valid_response_a = response_a.map((r) => re.test(r.trim()));
						const res = valid_response_a.includes(false) ? false : true;
						return res;
					};

					const checkRadios = (items_a, response, i) => {
						const re = new RegExp(items_a[i].validation_js.required);
						const res = re.test(response) ? true : false;
						return res;
					};

					const checkDropdown = (items_a, response, i) => {
						const re = new RegExp(items_a[i].validation_js.required);
						const res = re.test(response) ? true : false;
						return res;
					};

					const checkTextarea = (items_a, response, i) => {
						const re = new RegExp(items_a[i].validation_js.required);
						const res = re.test(response) ? true : false;
						return res;
					};

					const checkAffective = (items_a, response, i) => {
						const re = new RegExp(items_a[i].validation_js.required);
						const res = re.test(response) ? true : false;
						return res;
					};

					const checkMatchall = (items_a, response, i) => {
						const re = new RegExp(items_a[i].validation_js.required);
						const res = re.test(response) ? true : false;
						return res;
					};

					switch (elem.type) {
						case "text":
							res = checkText(state.items_a, elem.response_a, i);
							break;
						case "radios":
							res = checkRadios(state.items_a, elem.response, i);
							break;
						case "dropdown":
							res = checkDropdown(state.items_a, elem.response, i);
							break;
						case "textarea":
							res = checkTextarea(state.items_a, elem.response, i);
							break;
						case "affective":
							res = checkAffective(state.items_a, elem.response, i);
							break;
						case "check_several":
							res = checkMatchall(state.items_a, elem.response, i);
							break;

						default:
							res = false;
					}
					// If an item is complete, return true
					// otherwise return the index
					res = res ? true : i;
					return res;
				})
				.filter((elem) => elem !== true);
			if (!state.init_complete_bool) {
				state.init_complete_bool = true;
			}
		},
		setSaveData: (state, action) => {
			let js = action.payload;
			state.saved_bool = js.saved_bool;
		},
		setItemsShowExplanation: (state, action) => {
			// dispatch(setItemsShowExplanation({value: true|false}))
			let js = action.payload;
			state.items_show_explanation_bool = js.value;
		},
		setPostCompletionHTMLShow: (state, action) => {
			// dispatch(setPostCompletionHTMLShow({value: true|false}))
			let js = action.payload;
			state.post_completion_html_show_bool = js.value;
		},
		setItemsShowCheckAnswer: (state, action) => {
			// dispatch(setItemsShowCheckAnswer({value: true|false}))
			let js = action.payload;
			state.items_show_checkanswer_bool = js.value;
		}	
	}
});

export const { initActivityState, recordItem, setSaveData, setItemsShowExplanation, setPostCompletionHTMLShow, setItemsShowCheckAnswer } = activityStates.actions;

export const getUidData = (state) => {
	const datetime = getDBDateTimeNow();
	let score;
	try {
		score = state.activityStates.scores_js;
	} catch (e) {
		score = {earned: 0, possible: 0, percent: 0};
	}
	let results_a;
	try {
		results_a = state.activityStates.results_a;
	} catch (e) {
		results_a = [];
	}
	const data = {datetime, score, results_a};
	return data;
}

export const getPostCompletionHTMLShowBool = (state) => {
	let res;
	try {
		res = state.activityStates.post_completion_html_show_bool;
	} catch (e) {
		res = false;
	}
	return res;
}

export default activityStates.reducer;
